import { useRef, useState, useContext } from 'react';
import { useFormikContext } from 'formik';
import File from 'src/components/Attachments/File';
import ToastContext from 'src/contexts/toast-context';
import { Upload as UploadIcon } from '@mui/icons-material/';
import { Button } from '@mui/material';

/**
 *
 * @param {File}    file    - File object if one exists
 * @param {string}  title   - Title of file field
 *
 * @returns {JSX.Element}   - The Upload component.
 */

const MAX_FILE_SIZE_MB = 4;

const fileToLarge = ({ size }) => {
  return size / 1024 / 1024 > MAX_FILE_SIZE_MB;
};

export default function Upload({ files = [], title }) {
  const inputFileRef = useRef(null);

  const [uploadFiles, setUploadFiles] = useState(files);

  const form = useFormikContext();
  const { error } = useContext(ToastContext);

  const handleRemove = (file) => {
    // Remove file from state and formik form
    setUploadFiles(uploadFiles.filter((f) => f.name !== file.name));
    form.setFieldValue(
      `${title}`,
      uploadFiles.filter((f) => f.name !== file.name)
    );
  };

  return (
    <div className="flex flex-col flex-wrap items-start gap-x-4 gap-y-2 space-x-0 self-start">
      <Button
        onClick={() => {
          if (uploadFiles?.length >= 2) {
            error('Only a maximum of 2 files can be uploaded');
          } else {
            inputFileRef.current.click();
          }
        }}
        variant="outlined"
        endIcon={<UploadIcon />}
      >
        <input
          accept=".pdf, .doc, .docx, image/png, image/jpeg, .txt, .xls, .xlsx"
          className="hidden"
          id="file"
          name={title}
          onChange={(e) => {
            let file = e.target.files[0];
            if (fileToLarge(file)) {
              error(`File Exceeds ${MAX_FILE_SIZE_MB}MB limit`);
            } else {
              setUploadFiles([...uploadFiles, file]);
              form.setFieldValue(`${title}`, [...uploadFiles, file]);
            }
          }}
          ref={inputFileRef}
          type="file"
        />
        Upload
      </Button>
      {uploadFiles?.map((file) => (
        <File
          key={file?.name}
          fileName={file?.name}
          fileSize={file?.size}
          onRemove={handleRemove}
        />
      ))}
    </div>
  );
}
